import React, { useEffect } from 'react';

export function LightboxModal({ isOpen, image, title, description, onClose, onPrev, onNext }) {
  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft' && onPrev) onPrev();
      if (e.key === 'ArrowRight' && onNext) onNext();
    }
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose, onPrev, onNext]);

  if (!isOpen || !image) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
      {/* Close Button */}
      <button 
        onClick={onClose}
        className="absolute top-4 right-4 text-white/80 hover:text-white p-3 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-50 cursor-pointer"
        aria-label="Luk billede"
      >
        <i className="fa-solid fa-xmark text-2xl" aria-hidden="true" />
      </button>

      {/* Prev Button */}
      {onPrev && (
        <button
          onClick={onPrev}
          className="absolute left-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-50 cursor-pointer"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left text-xl" aria-hidden="true" />
        </button>
      )}

      {/* Next Button */}
      {onNext && (
        <button
          onClick={onNext}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white p-3.5 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-50 cursor-pointer"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right text-xl" aria-hidden="true" />
        </button>
      )}

      {/* Image and Caption */}
      <div className="max-w-5xl max-h-[90vh] flex flex-col items-center justify-center p-2">
        <img 
          src={image} 
          alt={title || "Galleri billede"} 
          className="max-h-[75vh] w-auto max-w-full object-contain rounded-lg shadow-2xl"
        />
        {(title || description) && (
          <div className="mt-4 text-center text-white max-w-xl">
            {title && <h3 className="font-bold text-lg text-white">{title}</h3>}
            {description && <p className="text-sm text-sand/80 mt-1">{description}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
